// store/listenerMiddleware.js
import { createListenerMiddleware } from "@reduxjs/toolkit";
import { addToCrate, clearCrate, removeFromCrate } from "../store";
import { updateQueue } from "../store";
import { useThunk } from "../hooks/useThunk";
import { updateCrateDB } from "../services/userThunks";
import { updateQueueDB, removeFromQueueDB } from "../services/userThunks";

const listenerMiddleware = createListenerMiddleware();

// Listen for Crate actions
listenerMiddleware.startListening({
	matcher: (action) =>
		[addToCrate.type, removeFromCrate.type, clearCrate.type].includes(
			action.type
		),
	effect: async (action, listenerApi) => {
		const state = listenerApi.getState();
		const userId = state.auth?.user?._id;
		const crateItems = state.crate.items;

		try {
			await listenerApi.dispatch(updateCrateDB({ userId, crateItems }));
			//  const result = await doUpdateCrate({userId, crateItems});
		} catch (err) {
			console.error("Failed to sync crate:", err);
		}
	},
});

listenerMiddleware.startListening({
	matcher: (action) => action.type === updateQueue.type,
	effect: async (action, listenerApi) => {
		const state = listenerApi.getState();
		const currentTracks = action.payload.tracks || [];
		
		// Get previous state to determine what changed
		const prevState = listenerApi.getOriginalState();
		const previousTracks = prevState?.queue?.tracks || [];

		// Find tracks that were added (in current but not in previous)
		const addedTracks = currentTracks.filter(
			(current) =>
				!previousTracks.some(
					(prev) =>
						prev.trackId === current.trackId &&
						prev.queueTrackId === current.queueTrackId
				)
		);

		// Find tracks that were removed (in previous but not in current)
		const removedTracks = previousTracks.filter(
			(prev) =>
				!currentTracks.some(
					(current) =>
						current.trackId === prev.trackId &&
						current.queueTrackId === prev.queueTrackId
				)
		);

		try {
			// Handle additions
			if (addedTracks.length > 0) {
				console.log("Adding tracks:", addedTracks);
				await listenerApi.dispatch(
					updateQueueDB({ tracks: addedTracks })
				);
			}

			// Handle removals
			if (removedTracks.length > 0) {
				// Send each removed track individually to avoid clearing all tracks
				for (const removedTrack of removedTracks) {
					const editId = removedTrack.editInfos?.[0]?.id;
					if (editId) {
						console.log("Removing single track:", [editId]);
						await listenerApi.dispatch(
							removeFromQueueDB({ editIds: [editId] })
						);
					}
				}
			}
		} catch (err) {
			console.error("❌ Failed to sync queue:", err);
		}
	},
});

export default listenerMiddleware;
